import { getCollectionById } from './getCollectionById';
export const resolveCollectionHref = (collectionId) => getCollectionById(collectionId)?.route;
//# sourceMappingURL=resolveCollectionHref.js.map